import { useTranslation } from 'react-i18next';
import Sifra from '../../../../../shared/components/Sifra';
import { icons } from '../../../../../shared/icons';
import { formatDateFromDB } from '../../../../../utils/FormatDate';
import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import GridOptions from './GridOptions';

const GridProvider = ({
  data = [],
  handleEditData,
  handleOpenPregledServisaKlijenti,
  handleOpenDeleteDialog,
  onSearchChange,
  savedFilter,
}) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: t('options'),
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.row.idDok)}
          getEditData={() => handleEditData(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    {
      field: 'ceoBrDok',
      headerName: t('docNumber'),
      width: 120,
      renderCell: (e) => {
        const idFirme = localStorage.getItem('idFirme');

        const handleClick = () => {
          if (idFirme === '1') {
            handleEditData(e.row);
          } else {
            handleOpenPregledServisaKlijenti(e.row);
          }
        };

        return <Sifra displayValue={e.value} onClick={handleClick} />;
      },
    },
    // {
    //   field: 'ceoBrDokServisnogZahteva',
    //   headerName: t('requestNumber'),
    //   width: 120,
    // },
    {
      field: 'nazivMasine',
      headerName: t('robot/mold'),
      width: 250,
    },
    ...(localStorage.idFirme === '1'
      ? [
          {
            field: 'nazivKupca',
            headerName: t('client'),
            width: 250,
          },
        ]
      : []),

    {
      field: 'datum',
      headerName: t('date'),

      width: 150,
      renderCell: (e) => formatDateFromDB(e.row.datum),
    },
    { field: 'status', headerName: t('status'), width: 150 },
    { field: 'zaposleniRn', headerName: t('Zaposleni'), width: 500 },
    { field: 'nazivPodProjekta', headerName: t('subProject'), width: 200 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid
        data={data}
        columns={columns}
        onSearchChange={onSearchChange}
        savedFilter={savedFilter}
      />
    </div>
  );
};

export default GridProvider;
